import callAPiBase from './base';

const studentsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolListUsers',
      method: 'GET',
      useToken: true,
      title: 'Student - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolAddUsers',
      method: 'POST',
      useToken: true,
      title: 'Student - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolUpdateUsers',
      method: 'POST',
      useToken: true,
      title: 'Student - Update',
      data,
    }),
  delete: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolDeleteUsers',
      method: 'POST',
      useToken: true,
      title: 'Student - Delete',
      data,
    }),
  checkUsers: ({ data }: { data: object }) =>
      callAPiBase({
        endpoint: '/schoolCheckUsers',
        method: 'POST',
        useToken: true,
        title: 'School - Check Users',
        data,
    }),
};

export { studentsApi };
export default studentsApi;
